var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDmFullColourSa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 522.95 120.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.17,120.39c-3.79,.2-7.22-.06-8.18-.14-1.51-.13-3.52-.4-5.02-.63-1.04-.16-2.43-.44-3.45-.7s-2.45-.6-3.48-.92c-1.55-.48-3.61-1.17-5.12-1.77-1.16-.46-2.69-1.12-3.81-1.67-1.41-.69-3.28-1.62-4.61-2.45-1.12-.7-2.63-1.62-3.72-2.38-1.26-.88-2.9-2.11-4.08-3.09-2.5-2.07-4.83-4.32-6.91-6.7-2.19-2.5-4.03-4.98-5.81-7.81-1.51-2.42-3.18-5.85-4.38-8.43-.65-1.4-1.32-3.35-1.79-4.82-.46-1.4-.93-3.32-1.33-4.74-.43-1.54-.83-3.64-1.01-5.23-.16-1.44-.42-3.37-.51-4.82-.1-1.56-.15-3.64-.12-5.21,.03-1.42,.14-3.31,.29-4.72,.16-1.54,.46-3.59,.74-5.12,.25-1.37,.67-3.18,1.04-4.52,.42-1.51,1.1-3.49,1.59-4.99,.51-1.58,1.38-3.62,2.14-5.1,1.21-2.37,2.88-5.52,4.38-7.72,1.01-1.47,2.43-3.38,3.54-4.77,.78-.98,1.91-2.22,2.76-3.13,1.21-1.3,2.96-2.91,4.28-4.1,.79-.72,1.91-1.6,2.75-2.25,.96-.74,2.26-1.69,3.27-2.35,1.33-.87,3.14-1.96,4.52-2.74,.26-.15,2.07-1.13,3.89-1.95,.47-.21,1.09-.49,1.56-.69s1.06-.44,1.52-.62c.41-.16,.97-.37,1.39-.52,.02,0,1.55-.58,3.84-1.25,.65-.19,1.99-.56,3.61-.92,1.8-.4,3.15-.62,3.8-.72,.85-.13,1.99-.28,2.85-.38,.5-.06,1.17-.12,1.68-.16,.8-.05,1.86-.12,2.65-.15,.69-.03,1.6-.04,2.29-.04,1.45,0,3.39,.09,4.83,.21,1.6,.12,4.82,.46,8.49,1.32,1.05,.24,2.44,.59,3.47,.91,1.55,.48,3.61,1.18,5.13,1.76,1.17,.44,2.69,1.11,3.81,1.66,1.41,.69,3.26,1.66,4.61,2.45,2.3,1.34,5.17,3.42,7.29,5.03,1.25,.95,2.83,2.32,3.92,3.44s2.51,2.53,3.52,3.67c.92,1.04,2.13,2.46,2.93,3.59,.88,1.25,2.08,2.91,2.89,4.2,.76,1.2,1.7,2.84,2.35,4.1,.72,1.38,1.6,3.26,2.2,4.69,.56,1.34,1.2,3.18,1.68,4.55,.72,2.05,1.45,4.87,1.82,7,.51,2.86,.96,6.73,1.12,9.63,.08,1.56,.1,3.64-.04,5.19-.13,1.41-.24,3.29-.43,4.69-.21,1.54-.56,3.58-.9,5.1-.3,1.35-.76,3.14-1.17,4.47-.47,1.51-1.21,3.48-1.74,4.96-.57,1.58-1.57,3.6-2.33,5.1-1.25,2.47-4.01,7.35-8.38,12.3-.82,.92-1.94,2.12-2.81,2.99s-2.09,1.98-3.02,2.79c-1.56,1.38-3.8,3-5.49,4.22,14.66-9.99,21.66-29.95,16.33-52.37C102.9,26.45,74.4,2.32,46.65,3.75c27.74-1.43,56.25,22.71,63.66,53.9,5.33,22.42-1.67,42.38-16.33,52.37-1.65,1.11-3.93,2.58-7,4.11-3.77,1.87-6.71,2.86-7.68,3.19-1.63,.55-3.14,.97-3.7,1.11q-1.58,.41-2.41,.59t-2.49,.5c-1.58,.3-3.52,.52-4.16,.6-.43,.05-1.62,.17-3.39,.27Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.45,28.45c-.24,.06-.48,.12-.72,.18,.24-.06,.48-.12,.72-.18",
    style: {
      fill: "#92c15f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.79,14.49c2.55,8.96,4.57,12.21,5.66,13.96,5.03-1.3,9.92-2.83,14.37-4.51,3.53-1.95,3.37-4.91-.48-8.8-1.7-1.49-3.42-2.87-5.17-4.1-2.55-1.63-4.06-1.75-4.88-1.56-2.97,1.23-6.42,2.33-9.97,3.2,.12,.48,.27,1.07,.48,1.81",
    style: {
      fill: "#92c15f"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.01,30.07c2.65,2.01,8.7,3.02,17.64,2.56,7.83-.4,16.64-1.87,25.08-4,.24-.06,.48-.12,.72-.18-2.41-3.87-4.48-9.18-6.14-15.77-4.22,1.03-8.58,1.74-12.48,1.94-4.57,.23-7.68-.27-9.09-1.28-1.71,1.72-2.98,3.79-4.49,5.67-4.28,5.31-8.67,10.52-11.18,10.99-.01,.02-.03,.05-.05,.07",
    style: {
      fill: "#ea506c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.01,30.07c-.21-.16-.41-.33-.58-.51,.17,.18,.36,.34,.58,.51",
    style: {
      fill: "#ea506c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.16,20.74c-4.06,4.27-6.64,8.94-5.12,9.26,.02,0,.02,0,.02,0,1.09-.06,3.05-1.62,5.83-4.63,.1-.11,10.08-11.51,9.66-12.16-.27-.1-.79,.05-2.56,1.1-1.07,.68-4.33,2.75-7.83,6.43",
    style: {
      fill: "#103544"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.17,7.39c-2.84,1.64-3.14,1.81-4.98,3.05-4.13,3-5.77,4.24-9.85,8.39-1.45,1.64-3.33,3.86-4.68,5.58-1.51,2.02-1.55,3.77-.23,5.14,.17,.18,.36,.34,.58,.51,.02-.02,.03-.05,.05-.07,0,0,0,0,0,0-2.15-.47,3.55-9.56,12.16-15.21,.23-.15,.53-.34,.76-.48,1.8-1.07,2.31-1.21,2.57-1.09,0,.04,.02,.09,.03,.12,.02-.02,.05-.03,.07-.05-1.52-1.15-.9-2.94,2.19-5.04,.82-.56,1.76-1.11,2.81-1.64l-1.49,.79",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.35,4.9q9.88,3.07,10.6,2.92c-.05-.09-.11-.2-.16-.29-.42-.39-.96-.75-1.61-1.08-1.99-.92-4.66-2.09-6.7-2.89-2.75-.9-6.18-2.02-10.42-2.74C67.02,.39,64.39,0,59.83,0c4.25-.05,6.98,.61,7.94,1.78,.55,.32,.81,.39,3.29,1.06,3,.8,3.73,1.01,7.03,1.98,.09,.03,.17,.05,.26,.08",
    style: {
      fill: "#92c15f"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.45,28.45c-.24,.06-.48,.12-.72,.18,.24-.06,.48-.12,.72-.18",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.79,14.49c2.55,8.96,4.57,12.21,5.66,13.96,5.03-1.3,9.92-2.83,14.37-4.51,3.53-1.95,3.37-4.91-.48-8.8-1.7-1.49-3.42-2.87-5.17-4.1-2.55-1.63-4.06-1.75-4.88-1.56-2.97,1.23-6.42,2.33-9.97,3.2,.12,.48,.27,1.07,.48,1.81",
    style: {
      fill: "#1d1d1b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.01,30.07c2.65,2.01,8.7,3.02,17.64,2.56,7.83-.4,16.64-1.87,25.08-4,.24-.06,.48-.12,.72-.18-2.41-3.87-4.48-9.18-6.14-15.77-4.22,1.03-8.58,1.74-12.48,1.94-4.57,.23-7.68-.27-9.09-1.28-1.71,1.72-2.98,3.79-4.49,5.67-4.28,5.31-8.67,10.52-11.18,10.99-.01,.02-.03,.05-.05,.07",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.01,30.07c-.21-.16-.41-.33-.58-.51,.17,.18,.36,.34,.58,.51",
    style: {
      fill: "#1d1d1b"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.16,20.74c-4.06,4.27-6.64,8.94-5.12,9.26,.02,0,.02,0,.02,0,1.09-.06,3.05-1.62,5.83-4.63,.1-.11,10.08-11.51,9.66-12.16-.27-.1-.79,.05-2.56,1.1-1.07,.68-4.33,2.75-7.83,6.43",
    style: {
      fill: "#1d1d1b",
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.49,51.75c2.65,9.71,11.71,16.32,15.58,19.14,16.47-2.39,34.01-7.13,47.88-12.83,14.05-7.9,6.15-23.03,.13-24.39-1.45-.33-2.47,.02-3.3,.29-16.07,7.76-40.85,14.13-60.67,15.15-.05,0-.1,0-.15,0,.16,.79,.32,1.85,.53,2.63",
    style: {
      fill: "#d8d44e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92,44.55c-1.36,5.92-1.41,6.15-1.78,9.64-.38,6.2-.38,6.32-.2,9.54-.08-1.97-.03-7.7,2.12-18.28,.57-2.77,.63-3.06,.76-3.78,.02-.11,.05-.22,.06-.33l-.97,3.22",
    style: {
      fill: "#168e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83,41.68c-.94,5.19,7.75,8.26,24.13,7.44l.53,2.63c2.73,7.88,6.51,12.53,15.58,19.14-5.16,.75-10.21,1.27-15.01,1.52C10.41,73.31,.47,70.31,.04,65.05l-.07-.94-.02-.38v-.05c-.12-3.06,.19-8.84,2.28-18.99,.27-1.32,.45-2.2,.6-3m0-.02s0-.01,0-.02c0,0,0,0,0,.01,0,0,0,0,0,0",
    style: {
      fill: "#f8d200"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.49,51.75c2.65,9.71,11.71,16.32,15.58,19.14,16.47-2.39,34.01-7.13,47.88-12.83,14.05-7.9,6.15-23.03,.13-24.39-1.45-.33-2.47,.02-3.3,.29-16.07,7.76-40.85,14.13-60.67,15.15-.05,0-.1,0-.15,0,.16,.79,.32,1.85,.53,2.63",
    style: {
      mixBlendMode: "multiply",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83,41.68c-.94,5.19,7.75,8.26,24.13,7.44l.53,2.63c2.73,7.88,6.51,12.53,15.58,19.14-5.16,.75-10.21,1.27-15.01,1.52C10.41,73.31,.47,70.31,.04,65.05l-.07-.94-.02-.38v-.05c-.12-3.06,.19-8.84,2.28-18.99,.27-1.32,.45-2.2,.6-3m0-.02s0-.01,0-.02c0,0,0,0,0,.01,0,0,0,0,0,0",
    style: {
      mixBlendMode: "multiply",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.52,39.94c.84,1.35,5.24,7.94,9.5,5.17,2.81-2.89,3.72-5.46,2.86-7.58l-.36-.87c-2.7-5.72-2.75-5.83-4.62-8.79-3.47-5-3.6-5.2-5.93-7.81l-2.63-2.75c2.12,2.07,1.74,4.85-1.43,8.1-2.72,4.15,.83,11.31,1.24,12.11,.47,.8,.93,1.61,1.37,2.42",
    style: {
      fill: "#ea506c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89,41.33c-.02,.1-.03,.21-.05,.31,.04-.24,.11-.48,.19-.73l-.14,.42",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8,89.4c7.41,2.95,14.24,12.43,8.04,17.67,19.71-1.75,43.05-8.19,57.71-15.77,6.08-3.89,7.75-10.04,8.18-12.5,.1-.83,.17-1.67,.23-2.51,0-1.91-.54-7.94-7.54-5.22-16.97,8.77-43.99,16.23-66.8,18.26,.06,.02,.13,.05,.18,.07",
    style: {
      fill: "#ea506c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.15,100.62c.77,1.19,3.62,5.19,8.06,6.87,.65-.02,1.31-.05,1.98-.08,1.52-.08,3.07-.19,4.64-.33,5.97-4.6,.19-14.51-8.22-17.75-1.82,.16-3.62,.29-5.38,.38-.73,.04-1.44,.07-2.14,.09-2.47,2.54-1.25,7.26,1.05,10.82",
    style: {
      fill: "#e6273b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22,92.5c3.46,5.01,3.59,5.2,5.91,7.82,.98,1.01,2.25,2.4,3.26,3.38,.53,.51,1.22,.97,2.05,1.38-.25-.49-10.84-16.21-12.28-18.09-1.02-.51-1.84-1.09-2.46-1.72,.02,.88,.74,2.36,1.37,3.55l2.15,3.68",
    style: {
      fill: "#ee750b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31,87.19c1.22,1.6,11.83,17.33,12.1,17.83,3.63,1.86,10,2.76,18.8,2.47-7.73-2.93-13.18-13.5-9.11-17.69-10.32,.36-17.77-.7-21.94-2.81,.05,.06,.11,.14,.15,.2",
    style: {
      fill: "#ea506c"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.8,89.4c7.41,2.95,14.24,12.43,8.04,17.67,19.71-1.75,43.05-8.19,57.71-15.77,6.08-3.89,7.75-10.04,8.18-12.5,.1-.83,.17-1.67,.23-2.51,0-1.91-.54-7.94-7.54-5.22-16.97,8.77-43.99,16.23-66.8,18.26,.06,.02,.13,.05,.18,.07",
    style: {
      fill: "#1d1d1b",
      mixBlendMode: "multiply",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.15,100.62c.77,1.19,3.62,5.19,8.06,6.87,.65-.02,1.31-.05,1.98-.08,1.52-.08,3.07-.19,4.64-.33,5.97-4.6,.19-14.51-8.22-17.75-1.82,.16-3.62,.29-5.38,.38-.73,.04-1.44,.07-2.14,.09-2.47,2.54-1.25,7.26,1.05,10.82",
    style: {
      fill: "#1d1d1b",
      mixBlendMode: "multiply",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31,87.19c1.22,1.6,11.83,17.33,12.1,17.83,3.63,1.86,10,2.76,18.8,2.47-7.73-2.93-13.18-13.5-9.11-17.69-10.32,.36-17.77-.7-21.94-2.81,.05,.06,.11,.14,.15,.2",
    style: {
      fill: "#1d1d1b",
      mixBlendMode: "multiply",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.62,83.71c.73,1.54,1.66,3.62,2.46,5.13-.49-.95-1.39-2.73-1.37-3.56-.49-.5-.86-1.03-1.1-1.6v.03",
    style: {
      fill: "#d8d44e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.33,81.61c0,.05-.48,5.27,2.08,3.26,1.83-1.64,2.98-3.17,3.47-4.57l.87-2.63c1.53-5.86,1.59-6.09,2.07-9.57,.56-6.13,.58-6.37,.47-9.88l-.1-2c-.15,2.18-.63,3.54-3.2,6.3-3.99,5.03-4.98,13.31-5.02,13.66-.12,1.85-.34,3.66-.64,5.43",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9,116.79c.48,1.29,2.38,1.43,3.86,1.15,0,0,0,0,0,0,.78-.16,1.51-.37,2.44-.72,0,0,0,0,0,0,6.06-2.36,7.27-6.24,5.31-7.15-.59-.27-1.22-.26-1.59-.26,0,0,0,0,0,0-.69,.04-1.27,.12-2.31,.42-1.29,.39-2.11,.8-2.6,1.04,0,0,0,0,0,0-4.32,2.27-5.46,4.39-5.11,5.52",
    style: {
      fill: "#ee750b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.19,117.22c2.53-.8,4.89-1.7,6.92-2.66,4.55-2.2,6.54-3.72,8.13-4.93,.78-.63,1.53-1.3,2.25-2.01,1.79-1.89,2.23-2.67,1.9-3.35-.63-.17-.92-.07-2.03,.37-3.95,1.87-8.54,3.63-13.45,5.18,0,0,0,0,0,0,3.41-.06,2.87,2.59,.98,4.51-1.12,1.14-2.7,2.12-4.69,2.89,0,0,0,0,0,0",
    style: {
      fill: "#f6a96c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.08,115.78c4.32,.91,9.92,4.38,9.95,4.41,3.78-.37,7.87-1.18,11.72-2.25,0,0,0,0,0,0-2.81,.51-4.92-.68-3.42-2.98,.56-.85,1.82-2.19,4.67-3.69,0,0,0,0,0,0-7.6,2.11-15.67,3.7-23.16,4.47,.07,.01,.16,.03,.23,.05",
    style: {
      fill: "#f2ae21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.98,110.02c-.68,.44-1.57,1.06-2.28,1.48s-1.57,.94-2.25,1.33-1.61,.89-2.32,1.23c-.59,.29-1.37,.68-1.97,.95-.92,.41-2.15,.93-3.09,1.31-.38,.15-1.8,.71-4.03,1.42-.41,.13-1.28,.4-2.45,.71q-.81,.22-2.41,.59c-.36,.09-1.71,.39-3.78,.72-4.19,.67-7.81,.72-8.49,.72-2.87,.01-9.53,.01-17.88-2.46-4.23-1.25-7.28-2.67-7.31-2.69-1.63-.76-3.78-1.83-5.35-2.69-1.16-.64-2.64-1.59-3.75-2.31-1.38-.89-3.17-2.16-4.41-3.24-1.03-.89-2.44-2.04-3.42-2.98-1.14-1.09-2.66-2.55-3.67-3.76-.89-1.07-2.11-2.46-2.95-3.57-.94-1.24-2.13-2.94-2.96-4.25-1.8-2.84-3.26-5.64-4.61-8.8-1.26-2.97-2.32-6.19-3.12-9.55C.81,71.3,.33,67.42,0,64.5c-.17-1.54-.23-3.63-.15-5.18,.08-1.42,.12-3.31,.25-4.72,.15-1.52,.42-3.55,.69-5.05,.75-4.18,1.81-7.45,2.49-9.38,.46-1.29,1.12-2.98,1.68-4.23,.63-1.4,1.57-3.22,2.26-4.58,.6-1.19,1.54-2.7,2.27-3.81,.86-1.31,2.09-2.98,3.01-4.25,1.04-1.43,2.59-3.2,3.83-4.46,.77-.78,1.77-1.85,2.59-2.57,1.6-1.42,3.79-3.24,5.48-4.56,.42-.32,3.19-2.34,6.31-4.07,1.03-.57,2.45-1.34,4.29-2.18,2.05-.94,3.53-1.48,4.5-1.84,1.23-.46,4.55-1.6,8.68-2.44,3.93-.79,7.21-1.03,8.81-1.11,1.37-.06,3.21-.09,4.58-.06,1.47,.04,3.44,.16,4.9,.32,1.08,.12,2.52,.28,3.58,.49,2.09,.41,4.86,1.04,6.91,1.59,1.07,.29,2.47,.77,3.51,1.15,1.16,.43,2.69,1.06,3.84,1.54,1.66,.7,3.83,1.75,5.37,2.69,1.13,.69,2.66,1.56,3.75,2.3,1.36,.92,3.17,2.17,4.42,3.23,4.26,3.62,4.84,4.22,7.1,6.73,1.87,2.07,4.09,5.07,5.65,7.38,.88,1.3,1.92,3.13,2.66,4.52s1.69,3.25,2.24,4.71c1.04,2.73,2.27,6.44,3.07,9.25,.44,1.54,.75,3.66,1.04,5.23,.27,1.43,.47,3.37,.54,4.82,.11,2.1,.16,4.91,.1,7.01-.08,2.74-.49,6.01-1.24,9.71-.72,3.58-2.14,7.83-2.77,9.29-.62,1.44-1.37,3.4-2.1,4.78-1.24,2.34-2.99,5.42-4.46,7.62-.87,1.3-2.15,2.97-3.15,4.18-1.16,1.39-2.78,3.17-4.06,4.45-3.79,3.77-7.33,6.21-8.5,7.01-5.74,3.91-12.66,6.3-20.47,6.7,7.81-.4,14.73-2.79,20.47-6.7Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.57,15.34s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0m.34-.18s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0m1.35-.84h0s0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0m.3-.21h0s0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,.01,0,0,0,0,0,0,0m5.65-7.68h0s0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m0,0s0,0,0,0c0,0,0,0,0,0m.19,2c.46-.59,1.62-2.2,1.53-2.62-.12-.06-.16-.08-.64,.12-.05,.02-.05,.02-.05,.02,0,0,0,0,0,0-.02,0-.04,.02-.06,.03-.01,0-.01,0-.02,0,0,0,0,0,0,0-.07,.03-.13,.06-.2,.09-1.56,.71-2.87,1.47-3.57,1.88-6.83,4.21-8.39,7.79-7.22,8.17,.44,.15,1.19-.16,1.59-.32-.02,0-.04,.02-.06,.03,.77-.34,1.46-.78,1.82-1.01l.23-.15c2.99-2.04,5.64-4.97,6.63-6.23",
    style: {
      fill: "#168e38"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "27.89 13.9 27.89 13.91 27.89 13.9",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.9 13.9 27.89 13.9 27.9 13.9",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.9 13.9 27.9 13.9 27.9 13.9",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.91 13.89 27.9 13.9 27.91 13.89",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.91 13.89 27.91 13.89 27.91 13.89",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.92 13.88 27.91 13.89 27.92 13.88",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.92 13.88 27.92 13.88 27.92 13.88",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.93 13.88 27.92 13.88 27.93 13.88",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.93 13.87 27.93 13.88 27.93 13.87",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.94 13.87 27.93 13.87 27.94 13.87",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.94 13.87 27.94 13.87 27.94 13.87",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.95 13.86 27.94 13.87 27.95 13.86",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.95 13.86 27.95 13.86 27.95 13.86",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.96 13.85 27.95 13.86 27.96 13.85",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.96 13.85 27.96 13.85 27.96 13.85",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.97 13.85 27.96 13.85 27.97 13.85",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.98 13.84 27.97 13.85 27.98 13.84",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.98 13.84 27.98 13.84 27.98 13.84",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.99 13.83 27.98 13.84 27.99 13.83",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.99 13.83 27.99 13.83 27.99 13.83",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28 13.83 27.99 13.83 28 13.83",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28 13.82 28 13.83 28 13.82",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28.01 13.82 28 13.82 28.01 13.82",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28.01 13.82 28.01 13.82 28.01 13.82",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28.02 13.81 28.01 13.82 28.02 13.81",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28.02 13.81 28.02 13.81 28.02 13.81",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28.03 13.8 28.02 13.81 28.03 13.8",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28.03 13.8 28.03 13.8 28.03 13.8",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28.04 13.8 28.03 13.8 28.04 13.8",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28.04 13.79 28.04 13.8 28.04 13.79",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28.05 13.79 28.04 13.79 28.05 13.79",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28.05 13.79 28.05 13.78 28.05 13.79",
    style: {
      fill: "#12aca2"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "27.46 14.21 27.45 14.22 27.46 14.21",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.46 14.21 27.46 14.21 27.46 14.21",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.46 14.21 27.46 14.21 27.46 14.21",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.47 14.2 27.46 14.21 27.47 14.2",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.47 14.2 27.47 14.2 27.47 14.2",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.48 14.2 27.47 14.2 27.48 14.2",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.48 14.19 27.48 14.2 27.48 14.19",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.49 14.19 27.48 14.19 27.49 14.19",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.49 14.19 27.49 14.19 27.49 14.19",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.5 14.18 27.49 14.19 27.5 14.18",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.5 14.18 27.5 14.18 27.5 14.18",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.5 14.18 27.5 14.18 27.5 14.18",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.51 14.18 27.5 14.18 27.51 14.18",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.51 14.17 27.51 14.18 27.51 14.17",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.52 14.17 27.51 14.17 27.52 14.17",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.52 14.17 27.52 14.17 27.52 14.17",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.52 14.17 27.53 14.16 27.52 14.17",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.53 14.16 27.53 14.16 27.53 14.16",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.53 14.16 27.54 14.16 27.53 14.16",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.54 14.16 27.54 14.15 27.54 14.16",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.54 14.15 27.55 14.15 27.54 14.15",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.55 14.15 27.55 14.15 27.55 14.15",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.55 14.14 27.55 14.15 27.55 14.14",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.56 14.14 27.55 14.14 27.56 14.14",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.56 14.14 27.56 14.14 27.56 14.14",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.56 14.14 27.57 14.13 27.56 14.14",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.57 14.13 27.57 14.13 27.57 14.13",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.58 14.13 27.57 14.13 27.58 14.13",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.58 14.12 27.58 14.13 27.58 14.12",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.58 14.12 27.59 14.12 27.58 14.12",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.59 14.12 27.59 14.12 27.59 14.12",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.59 14.12 27.6 14.11 27.59 14.12",
    style: {
      fill: "#12aca2"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "25.57 15.34 25.58 15.34 25.57 15.34",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.58 15.34 25.58 15.33 25.58 15.34",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.58 15.33 25.59 15.33 25.58 15.33",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.59 15.33 25.59 15.33 25.59 15.33",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.59 15.33 25.59 15.33 25.59 15.33",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.6 15.33 25.59 15.33 25.6 15.33",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.6 15.33 25.6 15.33 25.6 15.33",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.6 15.33 25.6 15.32 25.6 15.33",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.6 15.32 25.61 15.32 25.6 15.32",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.61 15.32 25.61 15.32 25.61 15.32",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.61 15.32 25.61 15.32 25.61 15.32",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.61 15.32 25.62 15.32 25.61 15.32",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.62 15.32 25.62 15.32 25.62 15.32",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.62 15.32 25.62 15.31 25.62 15.32",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.62 15.31 25.63 15.31 25.62 15.31",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.63 15.31 25.63 15.31 25.63 15.31",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.63 15.31 25.63 15.31 25.63 15.31",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.63 15.31 25.64 15.31 25.63 15.31",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.64 15.31 25.64 15.3 25.64 15.31",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.64 15.3 25.64 15.3 25.64 15.3",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.64 15.3 25.65 15.3 25.64 15.3",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.65 15.3 25.65 15.3 25.65 15.3",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.66 15.3 25.65 15.3 25.66 15.3",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.66 15.3 25.66 15.3 25.66 15.3",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.66 15.3 25.66 15.29 25.66 15.3",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.66 15.29 25.67 15.29 25.66 15.29",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.67 15.29 25.67 15.29 25.67 15.29",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.67 15.29 25.67 15.29 25.67 15.29",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.68 15.29 25.67 15.29 25.68 15.29",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.68 15.29 25.68 15.29 25.68 15.29",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.68 15.29 25.68 15.28 25.68 15.29",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.68 15.28 25.69 15.28 25.68 15.28",
    style: {
      fill: "#12aca2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.21,15.51s0,0,0,0c-3.48,1.55-6.54,3.19-8.99,4.86-2.11,1.44-3.62,2.8-4.56,4.05,1.36-1.71,3.22-3.96,4.68-5.58,3.39-3.37,4.94-4.91,9.85-8.39,2.98-1.93,3.09-2.01,4.98-3.05l1.49-.79c.27-.14,.55-.28,.84-.41l-.04,.02c.07-.03,.15-.07,.22-.1-1.14,.58-1.38,.7-2.11,1.12-7.04,4.12-9.16,8.13-7.88,8.56,.44,.15,1.19-.16,1.59-.32-.02,0-.05,.01-.06,.03",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "26.03 15.1 26.03 15.1 26.03 15.1",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.03 15.1 26.03 15.1 26.03 15.1",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.03 15.1 26.03 15.1 26.03 15.1",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.03 15.1 26.04 15.1 26.03 15.1",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.04 15.1 26.04 15.1 26.04 15.1",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.04 15.09 26.04 15.1 26.04 15.09",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.04 15.09 26.04 15.09 26.04 15.09",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.04 15.09 26.05 15.09 26.04 15.09",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.05 15.09 26.05 15.09 26.05 15.09",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.05 15.09 26.05 15.09 26.05 15.09",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.05 15.09 26.06 15.09 26.05 15.09",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.06 15.09 26.06 15.08 26.06 15.09",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.06 15.08 26.06 15.08 26.06 15.08",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.06 15.08 26.06 15.08 26.06 15.08",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.06 15.08 26.07 15.08 26.06 15.08",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.07 15.08 26.07 15.08 26.07 15.08",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.07 15.08 26.07 15.08 26.07 15.08",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.07 15.08 26.07 15.08 26.07 15.08",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.08 15.08 26.07 15.08 26.08 15.08",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.08 15.07 26.08 15.08 26.08 15.07",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.08 15.07 26.08 15.07 26.08 15.07",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.09 15.07 26.08 15.07 26.09 15.07",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.09 15.07 26.09 15.07 26.09 15.07",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.09 15.07 26.09 15.07 26.09 15.07",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.09 15.07 26.09 15.07 26.09 15.07",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.1 15.06 26.09 15.07 26.1 15.06",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.1 15.06 26.1 15.06 26.1 15.06",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.1 15.06 26.1 15.06 26.1 15.06",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.1 15.06 26.1 15.06 26.1 15.06",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.11 15.06 26.1 15.06 26.11 15.06",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.11 15.06 26.11 15.06 26.11 15.06",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.11 15.06 26.11 15.06 26.11 15.06",
    style: {
      fill: "#12aca2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.79,2.66c2.27,2.6-4.5,6.63-9.15,6.33-.9-.06-1.43-.27-1.66-.36-3.19-1.64-1.39-4.92,2.34-6.27,0,0,0,0,0,0,.34-.12,.68-.23,1.28-.38,.64-.16,1.05-.22,1.39-.27,0,0,0,0,0,0,3.9-.51,5.36,.5,5.81,.96",
    style: {
      fill: "#ee750b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.21,15.51s0,0,0,0c.58-.26,1-.48,1.82-1.01,4.35-2.89,8.4-7.94,8.39-9.01-.11-.05-.15-.08-.63,.11l-.05,.02-.07,.03c-.4,.17-.79,.37-1.18,.54,0,0,0,0,0,0,3.04-1.45,6.83-2.79,10.81-3.84,0,0,0,0,0,0-3.64,1.32-5.47,4.67-2.34,6.27,.43,.17,1.06,.37,2.14,.37-6.82,1.81-13.39,4.05-18.9,6.51",
    style: {
      fill: "#f8d200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.23,7.76h0c3.68-1.76,5.53-4.67,2.39-5.81-1.74-.63-3.92-.35-4.63-.26,0,0,0,0,0,0,3.81-.87,7.7-1.46,11.21-1.64,.57-.03,1.12-.05,1.65-.05,2.97,.05,5.77,.1,10.23,.83,2.82,.56,6.32,1.26,10.42,2.74,2.03,.81,4.72,1.95,6.7,2.89-3.06-1.52-8.66-2.24-16.45-1.84-6.73,.35-14.19,1.48-21.51,3.14",
    style: {
      fill: "#92c15f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.93,49.09Q.23,63.12,.12,63.76s0,.04-.01,.07c-.02,.09-.05,.2-.09,.28-.03-.11-.06-.27-.07-.38q-.12-6.36,.2-9.54c.85-6.03,.88-6.26,1.78-9.64l.97-3.22q-.08,.46-.96,7.76",
    style: {
      fill: "#168e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.12,63.75s0,0,0,0c0,0,0,.01,0,.02,0,.02,0,.04-.01,.07,0,0,0,.01,0,.02,0-.03,.01-.07,.02-.1m.02-.09h0s0-.01,0-.01c0,.03-.01,.07-.02,.1,0-.03,.01-.06,.02-.09m-.1,1.39c-.03-.39-.01-.79,.06-1.2-.04,.2-.05,.22-.08,.26-.04-.03-.05-.05-.07-.39,0,.11,.02,.27,.02,.38l.07,.94",
    style: {
      fill: "#f8d200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.09,31.36c2.26-4.13-2.21-13.54-10.06-17.89,7.24,.33,12.11,1.7,14.3,3.84l2.63,2.75c3.87,4.67,4.03,4.85,5.93,7.81,3.11,5.34,3.23,5.54,4.62,8.79l.36,.87c-1.41-3.47-7.55-5.73-17.78-6.18",
    style: {
      fill: "#ea506c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.14,63.66h0c1.09-7.43,1.43-14.94,2.75-22.33l.14-.42c.74-2.16,3.04-4.66,7.02-7.37C24.27,23.85,54.63,15,78.33,13.58c-3.36,4.47-1.33,12.27,9.05,17.89-27.34,1.56-62.53,11.79-78.97,23C3.4,57.89,.71,61.01,.14,63.66",
    style: {
      fill: "#59bbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.07,22.87c1.67,3.31,2.07,6.45,1.06,8.4-3.02-.04-6.34-.02-9.98,.17-.26,.01-.51,.03-.77,.04-10.15-5.28-12.6-13.4-9.05-17.89,.33-.02,.65-.04,.97-.05,3.21-.16,6.12-.18,8.72-.06,3.73,2.07,7.11,5.58,9.04,9.4",
    style: {
      fill: "#103544"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.17,93.77c1.48,2.12,4.49,6.22,8.1,9.8,.04,.04,.09,.09,.13,.13-.98-1.01-2.32-2.33-3.26-3.38-3.87-4.68-4.02-4.86-5.91-7.82l-2.15-3.68c.79,1.46,1.83,3.12,3.1,4.95",
    style: {
      fill: "#ee750b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.82,81.24c2.24,4.08,3.3,8.25,2.98,11.75-1.24,.93-2.27,1.83-3.1,2.69-5.19-1.42-12.82-12.38-12.28-19.6,.95-.98,2.13-2,3.53-3.05,1.86,.38,5.91,2.95,8.87,8.22",
    style: {
      fill: "#b9b01c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39,76.32c-.42,7.14,7.2,17.96,12.3,19.36-3.04,3.15-3.43,5.86-1.43,7.89-6.99-7.03-11.02-14.43-11.19-14.74-.75-1.53-1.78-3.56-2.46-5.13v-.03c-.91-2.12-.02-4.7,2.8-7.59,0,.07-.01,.17-.02,.24",
    style: {
      fill: "#d8d44e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5,79.9c1.96-6.56,1.39-15.89-6.08-22.41,42.26-12.39,73.32-10.61,74.76-1.27l.1,2c-.03,6.3-.03,6.42-.47,9.88-1.03,5.98-1.07,6.22-2.07,9.57l-.87,2.63c2.03-5.68-6.67-9.1-23.88-8.21-12.99,.67-28.12,3.65-41.5,7.82",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8,92.99c.59-9.44-6.75-18.83-11.85-19.97,.53-.4,1.1-.8,1.69-1.21,5.13-3.5,12.09-6.9,20.07-9.97-.51,9.72,5.33,18.25,9.63,21.2-7.2,2.73-13.49,5.77-18.08,8.9-.52,.35-1,.7-1.46,1.04",
    style: {
      fill: "#d8d44e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9,68.16c.65,2.7,1.11,6.94-.39,11.74-3.17,.99-6.24,2.04-9.16,3.15-4.31-2.94-10.14-11.47-9.63-21.2,4.02-1.55,8.29-3.01,12.72-4.36,1.35,1.18,4.94,4.31,6.47,10.67",
    style: {
      fill: "#168e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.98,108.38c3.63,3.87,13.3,7.55,21.14,8.05-1.37,2.2,.66,3.72,5.57,3.99-1.64-.02-2.77-.07-4.76-.27-1.19-.15-2.77-.35-3.95-.54-2.67-.54-6.32-1.27-10.4-2.76-1.77-.71-4.13-1.68-5.86-2.49-2.91-1.4-3.61-3.51-1.83-6.09,.03,.03,.06,.07,.09,.1",
    style: {
      fill: "#12aca2"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "54.39 115.21 54.39 115.2 54.39 115.21",
    style: {
      fill: "#0c868f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.15,111.04c2.74,1.4,5.5,2.76,8.24,4.16-.5,.43-.88,.84-1.15,1.24-7.92-.43-17.7-4.16-21.35-8.15,.52-.76,1.26-1.55,2.22-2.38,3.63,.85,9.74,3.96,12.04,5.13",
    style: {
      fill: "#0c868f"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "58.2 112.57 58.2 112.57 58.2 112.57",
    style: {
      fill: "#168e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.19,106.2c.68,.68,6.55,6.64,2.89,6.72-.9,.02-2.06-.23-2.55-.34-9.42-2.33-15.94-8.25-13.94-10.97,0,0,0,0,0,0,.2-.23,.36-.35,.65-.5,.25-.12,.49-.23,.94-.32,0,0,0,0,0,0,2.84-.43,7.66,1.07,12.02,5.41",
    style: {
      fill: "#168e38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.2,112.57c.06,.03,.12,.06,.18,.09-1.02,.52-1.94,1.06-2.74,1.6-.48,.33-.9,.64-1.25,.95h0c-11.3-5.77-16.46-8.4-20.28-9.3,.7-.61,1.52-1.23,2.46-1.88,1.2-.82,2.54-1.63,4.02-2.42,0,0,0,0,0,0-2,2.72,4.53,8.64,13.94,10.97,2.48,.54,3.21,.33,3.59,.06,.07-.07,.07-.07,.07-.07",
    style: {
      fill: "#3bbcdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.44,105.5c-1.14,.87-4.6,3.54-6.75,4.12,.62-2.3-2.85-3.63-9.64-3.29-8.12,.42-18.34,3.1-24.67,6.32-.06-.03-.12-.06-.18-.09h0c.91-2.23-8.06-12.66-16.03-11.78,0,0,0,0,0,0,12.43-6.27,32.35-11.48,48.19-12.29,13.33-.69,20.13,1.93,18.73,6.29-.25,.51-1.72,3.29-6.76,8.2-.93,.87-1.89,1.71-2.89,2.51",
    style: {
      fill: "#f2ae21"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140.09,52.93c0-13.59,9.86-20.97,20.27-20.97,7.77,0,14.68,4.27,17.63,10.87h.16V17.98h2.18v14.76h.08v40.39h-2.18v-10.1h-.23c-2.95,6.6-9.86,10.87-17.63,10.87-10.41,0-20.27-7.38-20.27-20.97Zm20.2,18.8c8.85,0,18.02-6.14,18.02-18.8s-9.17-18.8-18.02-18.8-17.87,6.06-17.87,18.8,9.09,18.8,17.87,18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.71,17.98h2.18v2.64h-2.18v-2.64Zm0,14.76h2.18v40.39h-2.18V32.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.87,63.42l2.18-.62c1.48,6.14,6.06,8.86,11.11,8.86s10.25-2.56,10.25-8.62c0-5.05-3.49-7.15-9.71-9.79l-2.33-1.01c-6.68-2.87-9.32-6.6-9.32-10.8,0-5.52,4.51-9.48,10.8-9.48,5.44,0,9.63,2.95,11.19,7.61l-1.94,.85c-1.48-3.5-4.12-6.21-9.24-6.21-4.43,0-8.54,2.18-8.54,7.15,0,3.65,2.25,6.29,7.69,8.62l1.86,.85c7.84,3.34,11.81,5.98,11.81,12.2,0,7.77-6.68,10.87-12.58,10.87-7.07,0-11.96-4.27-13.21-10.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.09,53.01c0-13.44,10.18-21.05,20.43-21.05,6.99,0,13.83,3.42,17.17,9.94l-1.94,.85c-3.03-5.67-9.01-8.62-14.99-8.62-9.01,0-18.33,6.53-18.33,18.88s9.32,18.72,18.33,18.72c5.98,0,11.96-2.95,14.99-8.62l1.94,.85c-3.34,6.53-10.18,9.94-17.17,9.94-10.25,0-20.43-7.61-20.43-20.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.88,52.93c0-13.36,10.18-20.97,20.58-20.97s20.58,7.61,20.58,20.97-10.25,20.97-20.58,20.97-20.58-7.61-20.58-20.97Zm20.58,18.8c9.17,0,18.25-6.53,18.25-18.8s-9.09-18.8-18.25-18.8-18.25,6.53-18.25,18.8,9.01,18.8,18.25,18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.45,32.74h2.41l15.92,37.13,15.92-37.13h2.41l-17.4,40.39h-1.86l-17.4-40.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.52,52.85c0-13.52,9.63-20.89,19.73-20.89s19.96,7.61,19.03,21.67h-36.51c.39,11.73,8.85,18.02,18.18,18.02,5.75,0,10.95-2.33,13.9-6.29l1.55,1.48c-3.81,4.66-9.79,7.07-15.69,7.07-10.49,0-20.2-7.46-20.2-21.05Zm36.82-1.4c-.31-10.95-8.23-17.24-17.17-17.24s-16.78,5.98-17.4,17.24h34.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.72,32.74h2.18v9.09c1.63-5.13,5.83-9.86,13.36-9.86,.93,0,1.48,.08,1.86,.23v1.94c-.47-.08-1.01-.16-1.79-.16-7.22,0-13.44,5.9-13.44,16v23.15h-2.18V32.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.81,50.14c0-5.75-3.03-8.85-7.46-8.85s-7.84,3.11-7.84,8.85v22.99h-10.41V32.74h10.41v5.2c2.17-3.42,5.9-5.98,11.57-5.98,4.97,0,9.32,2.1,11.81,6.76,2.33-3.73,6.76-6.76,13.36-6.76,8.54,0,14.76,5.36,14.76,17.71v23.46h-10.49v-22.99c0-5.75-2.95-8.85-7.46-8.85s-7.85,3.11-7.85,8.85v22.99h-10.41v-22.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.58,52.93c0-13.59,10.1-20.97,20.43-20.97s21.91,7.22,19.65,25.01h-30.22c1.48,5.52,6.29,8.39,12.35,8.39,3.96,0,7.46-1.09,10.41-3.65l4.74,5.05c-3.34,4.19-9.17,7.15-16.31,7.15-11.11,0-21.05-7.53-21.05-20.97Zm30.84-3.57c-.62-5.75-5.44-8.62-10.33-8.62s-9.48,2.8-10.8,8.62h21.13Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M291.21,109.48c-1.39-.98-2.08-2.35-2.08-4.12,0-.19,.02-.46,.06-.83h4.41c-.08,.86,.15,1.57,.69,2.13,.54,.56,1.34,.83,2.39,.83s1.88-.22,2.48-.66c.61-.44,.91-1.08,.91-1.9,0-.76-.31-1.37-.94-1.82-.63-.45-1.61-.96-2.95-1.51-1.23-.51-2.24-.99-3.01-1.42-.77-.43-1.43-1.03-1.98-1.81s-.82-1.74-.82-2.92c0-1.34,.34-2.5,1.03-3.49,.69-.99,1.64-1.75,2.84-2.28s2.58-.8,4.12-.8,2.84,.25,3.96,.76c1.12,.5,1.96,1.22,2.53,2.14,.56,.93,.81,2.01,.72,3.24h-4.6l.03-.34c0-.68-.25-1.23-.76-1.67-.51-.43-1.21-.65-2.12-.65-.97,0-1.75,.23-2.34,.68-.6,.45-.9,1.07-.9,1.85,0,.51,.17,.96,.51,1.34,.34,.38,.76,.71,1.25,.99,.49,.28,1.2,.63,2.13,1.06,1.21,.54,2.21,1.04,2.99,1.51,.78,.47,1.45,1.1,2.01,1.88,.55,.78,.83,1.74,.83,2.87,0,1.23-.33,2.33-1,3.3-.67,.97-1.62,1.72-2.84,2.27s-2.65,.82-4.27,.82c-2.16,0-3.94-.49-5.32-1.47Z",
    style: {
      fill: "#91c15f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.52,109.79c-1.39-.77-2.46-1.84-3.23-3.21-.76-1.37-1.14-2.94-1.14-4.71,0-2.47,.55-4.69,1.65-6.67s2.62-3.52,4.57-4.64c1.94-1.12,4.13-1.68,6.56-1.68,1.83,0,3.44,.38,4.83,1.14,1.39,.76,2.46,1.83,3.22,3.19,.76,1.37,1.14,2.93,1.14,4.67,0,2.51-.55,4.75-1.64,6.73-1.09,1.98-2.61,3.52-4.57,4.64-1.96,1.12-4.16,1.68-6.6,1.68-1.81,0-3.41-.39-4.8-1.16Zm9.5-4c1.18-.78,2.1-1.84,2.75-3.16s.97-2.77,.97-4.34c0-1.69-.47-3.01-1.42-3.98s-2.27-1.45-3.98-1.45c-1.52,0-2.88,.39-4.06,1.17-1.18,.78-2.1,1.83-2.75,3.15-.65,1.32-.97,2.76-.97,4.32,0,1.69,.47,3.02,1.4,4,.94,.98,2.26,1.47,3.97,1.47,1.54,0,2.91-.39,4.09-1.17Z",
    style: {
      fill: "#91c15f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.58,89.19l-2.34,13.3c-.08,.58-.12,.98-.12,1.2,0,1.07,.32,1.89,.96,2.45,.64,.57,1.54,.85,2.72,.85,1.4,0,2.55-.39,3.44-1.16,.9-.77,1.48-1.89,1.74-3.35l2.34-13.3h4.35l-2.35,13.3c-.33,1.85-1,3.41-2.01,4.67-1.01,1.27-2.23,2.21-3.66,2.84-1.43,.63-2.97,.94-4.61,.94-2.18,0-3.94-.57-5.29-1.7-1.35-1.13-2.02-2.76-2.02-4.88,0-.58,.06-1.2,.19-1.88l2.34-13.3h4.32Z",
    style: {
      fill: "#91c15f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.54,89.19l-.62,3.39h-5.71l-3.21,18.15h-4.35l3.21-18.15h-5.74l.62-3.39h15.8Z",
    style: {
      fill: "#91c15f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.61,89.19l-3.8,21.54h-4.35l1.64-9.23h-9.2l-1.64,9.23h-4.35l3.83-21.54h4.32l-1.57,8.92h9.23l1.57-8.92h4.32Z",
    style: {
      fill: "#91c15f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.36,106.62h-8.61l-2.13,4.1h-4.54l11.57-21.57h5.03l3.92,21.57h-4.57l-.68-4.1Zm-.56-3.36l-1.54-9.13-4.75,9.13h6.3Z",
    style: {
      fill: "#91c15f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.68,89.19l-.62,3.39h-8.95l-.99,5.65h6.85l-.59,3.33h-6.88l-1.6,9.17h-4.35l3.83-21.54h13.3Z",
    style: {
      fill: "#91c15f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.87,90.69c1.13,1,1.7,2.3,1.7,3.9,0,.39-.03,.79-.09,1.2-.25,1.4-.88,2.67-1.9,3.81s-2.38,1.94-4.09,2.39l3.61,8.73h-5.03l-3.21-8.39h-2.07l-1.48,8.39h-4.35l3.83-21.54h8.08c2.2,0,3.87,.5,5,1.5Zm-2.78,4.46c0-.78-.25-1.39-.74-1.82-.49-.43-1.25-.65-2.25-.65h-3.61l-1.14,6.45h3.61c1.15,0,2.07-.29,2.76-.86,.69-.58,1.13-1.37,1.31-2.38,.04-.37,.06-.62,.06-.74Z",
    style: {
      fill: "#91c15f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.93,89.19l-3.8,21.54h-4.35l3.83-21.54h4.32Z",
    style: {
      fill: "#91c15f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.73,94.24c1.25-1.68,2.78-2.98,4.6-3.92,1.82-.94,3.76-1.4,5.82-1.4,2.41,0,4.41,.62,6.02,1.85,1.61,1.23,2.57,2.94,2.9,5.12h-4.97c-.33-.99-.89-1.73-1.7-2.24-.8-.5-1.79-.76-2.96-.76-1.26,0-2.42,.29-3.5,.86s-1.99,1.4-2.72,2.47-1.22,2.3-1.47,3.7c-.1,.66-.15,1.2-.15,1.64,0,1.67,.48,2.98,1.43,3.95,.96,.97,2.26,1.45,3.9,1.45,1.17,0,2.25-.26,3.24-.77s1.82-1.27,2.5-2.25h4.97c-1.11,2.2-2.68,3.91-4.71,5.14-2.03,1.22-4.24,1.84-6.65,1.84-1.81,0-3.41-.37-4.8-1.1s-2.46-1.76-3.22-3.1c-.76-1.34-1.14-2.87-1.14-4.6,0-.72,.06-1.45,.19-2.19,.37-2.12,1.18-4.02,2.42-5.69Z",
    style: {
      fill: "#91c15f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.11,106.62h-8.61l-2.13,4.1h-4.54l11.57-21.57h5.03l3.92,21.57h-4.57l-.68-4.1Zm-.56-3.36l-1.54-9.13-4.75,9.13h6.3Z",
    style: {
      fill: "#91c15f"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmFullColourSa);
export default __webpack_public_path__ + "static/media/DMFullColourSA.ad4e10a411a41b87f8d0ac7064e9bef1.svg";
export { ForwardRef as ReactComponent };